<template lang="pug">
  .table-responsive
    LoaderTb(v-show="isLoading")
    .notification(v-if="entradas.length < 1 ")
      strong No hay Registros para esta fecha
    table#listEntradas.table.is-striped.is-fullwidth(v-else)
      thead
        tr
          th.is-size-6 
            | PG
          th.is-size-6 
            | Folio
          th.is-size-6 
            | Llenadera
          th.is-size-6 
            | Vol. C.
          th.is-size-6 
            | Masa
          th.is-size-6 
            | Entrada
          th.is-size-6 
            | Inicio
          th.is-size-6 
            | Fin
          th.is-size-6(v-show="permisos.sca_irge == 1")
            | Acción
      tbody
        tr(v-for="ent in entradas" :key="ent.Position")
          td
            span.tag.is-black  
              | {{ ent.id_pg }}
          td {{ ent.folioCarga }}
          td {{ ent.llenadera_llenado }}
          td {{ ent.volumen20_llenado }}
          td {{ ent.masaKgs_llenado }}
          td {{ ent.entrada_llenado }}
          td {{ ent.inicioCarga_llenado }}
          td {{ ent.finCarga_llenado }}
          td(v-show="permisos.sca_irge == 1")
            a.button.is-dark.is-small(@click="insertarDatos(ent)")
              | Insertar 
</template>

<script>
  import LoaderTb from '../componentes/LoaderTb.vue'
  import sca_irgeServices from '@/services/sca/irge.js'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'TbListCargas',
    components: { LoaderTb },
    props: {
      entradas: {
        type: Array,
        default: []
      },
    },
    watch: {
      isLoading() {
        if (this.isLoading) {
          this.classLoading = 'is-loading'
        } else {
          this.classLoading = ''
        }
      }
    },
    data() {
      return {
        isLoading: false,
        classLoading: '',
        configuracion: {},
        sca_cargasSCA_Pemex: false
      }
    },
    methods: {
      iniciarComponente(){
        this.obtenerConfiguracion()
      },

      obtenerConfiguracion () {
        this.configuracion = {}
        sca_irgeServices.obtenerConfiguracion()
          .then( data => {
            this.configuracion = this.convertirConfiguracion(data[0])
            this.sca_cargasSCA_Pemex = this.configuracion.sca_cargasSCA_Pemex
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
        
      },

      convertirConfiguracion(config) {
        return {
          ...config,
          sca_cargasSCA_Pemex: config.sca_cargasSCA_Pemex === '1' ? true : false,
        }
      },

      cambiarPertenencia(ent) {
        if (this.permisos.sca_irge == 7){
          return
        }
        this.isLoading = true
        console.log(ent)
        let isPem = 0
        let irge_Pem = 0

        switch (ent.isP) {
          case 0:
            console.log('Is 0')
            isPem = 1
            irge_Pem = 0
            break
          case 1:
            console.log('Is 1')
            isPem = 0
            irge_Pem = 1
            break
          case null:
            console.log('Is null')
            isPem = 0
            irge_Pem = 1
            break
        
          default:
            break
        }

        sca_irgeServices.cambiarIRGE_PEMEX( ent.LoadingBayNumber, ent.FolioPLC, irge_Pem)
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              sca_irgeServices.setPemTanksTrunks(ent.EntryID, ent.TankTruckID, isPem)
                .then( resp => {
                  if (resp.success) {
                    
                  } else {
                    console.log(resp.respuesta)
                  }
                  this.isLoading = false
                  this.$emit('updateTbListCargas', true)
                })
                .catch( e => {
                  console.log(e)
                  this.isLoading = false
                })
            } else {
              console.log(resp.respuesta)
            }
          })
          .catch((e) => console.log(e))
      },

      insertarDatos(emb) {
        if (this.permisos.sca_irge == 7){
          return
        }
        let tipoAutotanque = ''
        switch (emb.TankTruckTypeID) {
          case 0:
            tipoAutotanque = ''
            break
          case 1:
            tipoAutotanque = 'A'
            break
          case 2:
            tipoAutotanque = 'B'
            break
          
          default:
            break
        }
        const tanqueTipo= (`${emb.TankTruck.substring(2,emb.TankTruck.length)}`).trim()
        const claveLlenado = `${emb.EntryYear.substring(2,4)}${emb.EntryMonth}${emb.EntryDay}L-${emb.LoadingBayNumber}-${emb.FolioPLC}${tipoAutotanque}`
        const id_pg = `${emb.TankTruck.substring(0,2)}-${tanqueTipo}`
        const entradaLlenado = `${emb.EntryYear}-${emb.EntryMonth}-${emb.EntryDay} ${emb.LoadIniTime}:00`
        const folio =`${emb.FolioPLC}`
        const embarque = 0
        const inicioCarga = `${emb.EntryYear}-${emb.EntryMonth}-${emb.EntryDay} ${emb.LoadIniTime}:00`
        const finCarga = `${emb.EntryYear}-${emb.EntryMonth}-${emb.EntryDay} ${emb.LoadEndTime}:00`
        let _finCarga = moment(finCarga)
        let ahoraFinalJornada = `${emb.EntryYear}-${emb.EntryMonth}-${emb.EntryDay} 05:00:00`
        let _ahoraFinalJornada = moment(ahoraFinalJornada)
        let _fechaJornada = ''
        if (_ahoraFinalJornada.isBefore(_finCarga)) {
          _fechaJornada = _finCarga.format('YYYY-MM-DD')
        } else {
          _fechaJornada = _finCarga.subtract(1, 'days').format('YYYY-MM-DD')
        }
        const contenidoLlenado = `${emb.LoadVolNat_Lts}`
        const densidad = `0${emb.LoadDensityNat}`
        const densidad20 = `0${emb.LoadDensityCor}`
        const temperatura = `${emb.LoadTemp}`
        const presion = `${emb.LoadPres}`
        const masa = `${emb.LoadMass_Tons}`
        const masaKgs = `${emb.LoadMass_kgs}.0000`
        const masaPura = `${emb.LoadMass_kgs}`
        const volumenLlenado = `${emb.LoadVolNat_Bls}`
        const volumen20 = `${emb.LoadVolCor_Bls}`
        const volumenPuro = `${emb.LoadVolNat_Bls}`
        const volumen20Puro = `${emb.LoadVolCor_Bls}`
        const numeroLlenadera = `L-${emb.LoadingBayNumber}` 
        const porcentajeLlenado = `${emb.LoadPercent}`
        const capacidad = `${emb.Capacity}`
        const restante = `${emb.StandardCapacity}`
        const modo = 2
        const captura = 1
        const fechaEntrada = `NULL`
        const fechaSalida = `NULL`
        sca_irgeServices.insertarDatos(claveLlenado, id_pg, entradaLlenado, folio, embarque, inicioCarga,
        finCarga, _fechaJornada , contenidoLlenado, densidad, densidad20, temperatura, presion, masa, masaKgs, masaPura,
        volumenLlenado, volumen20, volumenPuro, volumen20Puro, numeroLlenadera, porcentajeLlenado, capacidad,
        restante, modo, captura, fechaEntrada, fechaSalida)
        .then(res => {
            this.$emit('insertarEmbarque', res)
          })
        .catch(error => console.log(error))
      }
    },
    computed: {
      ...mapState(['permisos'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/TbListCargas.vue